export default function Version() {
    if (import.meta.env.MODE === 'production') {
        return null;
    }
    return (
        <div className="fixed z-[9999] bottom-2 right-12 text-white text-xs">
            0.0.32
        </div>
    );
}
